import { Stack, Card, CardContent, CardHeader, Typography } from '@mui/material';
import { usePhrase } from '@/hooks';
import { ACCOUNT_PASSWORD_CHANGE_PHRASES } from '@/consts/phrases/accountPhrases';
import { JSXFromString } from '@/utils';
import { Icon } from '@/components/general/Icon/Icon';

interface PasswordRequirementsProps {
    tooltipText?: boolean;
}

export const PasswordRequirements = ({ tooltipText }: PasswordRequirementsProps) => {
    const { t } = usePhrase();
    return (
        <>
            {!tooltipText ? (
                <Card variant="outlined" className="requiredPasswordDescription">
                    <CardHeader
                        avatar={<Icon path="general/AskInformMark" />}
                        title={t(ACCOUNT_PASSWORD_CHANGE_PHRASES.PASS_REQUIREMENTS_TITLE)}
                        className="passwordRequirmentsTitle"
                        sx={{ pb: 0, pr: 1 }}
                    />
                    <CardContent sx={{ pt: 0, pr: 2, pb: 1 }}>
                        <Typography variant="subtitle2" className="passwordDescriptionContent">
                            {JSXFromString(
                                t(ACCOUNT_PASSWORD_CHANGE_PHRASES.PASS_REQUIREMENTS_LIST),
                            )}
                        </Typography>
                    </CardContent>
                </Card>
            ) : (
                <>
                    <Stack direction="row" spacing={2}>
                        <Icon path="general/AskInformMark" />
                        <Typography variant="h6" className="passwordRequirmentsTitle">
                            {t(ACCOUNT_PASSWORD_CHANGE_PHRASES.PASS_REQUIREMENTS_TITLE)}
                        </Typography>
                    </Stack>
                    <Typography variant="subtitle2" className="passwordDescriptionContent">
                        {JSXFromString(t(ACCOUNT_PASSWORD_CHANGE_PHRASES.PASS_REQUIREMENTS_LIST))}
                    </Typography>
                </>
            )}
        </>
    );
};
